import React, { useState } from 'react'

import TreeItem from '@material-ui/lab/TreeItem'
import { Indicator } from './Indicator'
import { IconMap } from '../../../utils/icons'
import { getDimensions } from '../../../utils/apiHelper'

export const SubTree = ({ children, id, name }) => {
  const [dimensions, setDimensions] = useState([])
  if (!children) {
    getDimensions({ id }).then(setDimensions)
  }

  return (
    <TreeItem
      collapseIcon={children && IconMap.get('DetailsOutlinedRotate')}
      expandIcon={children && IconMap.get('DetailsOutlined')}
      nodeId={id.toString()}
      label={name}
    >
      {children &&
        children?.map(
          ({
            area_id: areaId,
            indicator_id: indicatorId,
            name: label,
            children: items
          }) => (
            <SubTree
              key={areaId || indicatorId}
              id={(areaId || indicatorId).toString()}
              name={label}
            >
              {items}
            </SubTree>
          )
        )}
      {!children && <Indicator id={id} dimensions={dimensions} />}
    </TreeItem>
  )
}
